"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _Logo = _interopRequireDefault(require("../Logo"));
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
// TODO: We are keeping this export because it is used in many repositories
var _default = exports["default"] = _Logo["default"];